export default __webpack_public_path__ + "static/media/orchestrator.e67feb66.png";